// CTV-445: shared delivery-report aggregation. Lives in its own module (not the
// component file) so both the delivery card and the report page's PDF export can
// import it without tripping react-refresh's only-export-components rule.

export interface DailyPlay {
  date: string; // YYYY-MM-DD
  plays: number;
  completes?: number; // CTV-445: video completes for the day (absent on legacy responses)
}

export interface MonthlyRow {
  monthKey: string; // YYYY-MM
  label: string; // "April 2026"
  days: number;
  plays: number;
  dailyAvg: number;
}

export function aggregateMonthly(daily: DailyPlay[]): MonthlyRow[] {
  const map = new Map<string, { days: number; plays: number }>();
  for (const d of daily) {
    const key = d.date.slice(0, 7);
    const cur = map.get(key) ?? { days: 0, plays: 0 };
    cur.days += 1;
    cur.plays += d.plays;
    map.set(key, cur);
  }
  return Array.from(map.entries())
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([monthKey, v]) => {
      const [y, m] = monthKey.split('-').map(Number);
      const label = new Date(y, m - 1, 1).toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
      return {
        monthKey,
        label,
        days: v.days,
        plays: v.plays,
        dailyAvg: Math.round(v.plays / Math.max(1, v.days)),
      };
    });
}
